import type { ICarePlan } from "@domain/CarePlan";
import { ConditionType, type IConditionDto, ConditionBase, ConditionState, type IConditionLabelOptions, type IVehicle, ConfigurationType } from "..";
import { WorkOrderType } from "@domain/CarePlan/WorkOrders/WorkOrderType";

export class BatteryCondition extends ConditionBase
{

    constructor( vehicle: IVehicle, model: IConditionDto )
    {
        super( vehicle, model, ConditionType.Battery, ConfigurationType.Monthly, false );
        this.icon = 'dashboard:battery';
        this.ordinal = 5;
        this.initialise();
    }

    /**
     * Applies the care plan state to the condition
     * @param carePlan 
     */
    applyCarePlan( carePlan: ICarePlan )
    {
        this.workOrderConfiguration = carePlan.getItem( WorkOrderType.BatteryReplacement );
    }

    /**
     * Gets the labels for the condition.  The labels are used to provide meaningful
     * user interface statements/prompts that are specific to the condition
     */
    override getLabels(): IConditionLabelOptions 
    {
        return {
            name: 'Battery',
            shortName: 'Battery',
            longName: 'Battery Health',
            intervalJustCompletedMessage: 'Battery has just been checked/replaced',
            cta: 'Check or replace battery',
            maintenanceVerb: 'Battery Check',
            protectedByLabel: 'Your battery is protected by'
        };
    }

    /**
     * Gets the description for the interval update for this condition
     * @returns 
     */
    override getIntervalDescription()
    {
        if( this.averageOdometerInterval == 0 ) return 'n/a';
        return `A car battery should be checked or replaced ${ super.getIntervalDescription( this.vehicle, this ) }`;
    }

    /**
     * Gets the action message for the service note
     */
    override getActionMessage() 
    {
        switch( this.state )
        {
            case ConditionState.Due: return 'Check your battery and replace if necessary';
            case ConditionState.Overdue: return 'Check your battery and replace if necessary';
            case ConditionState.Critical: return 'A battery warning is detected, contact your dealer for assistance';
            default: return '';
        }
    }
    
}
